/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

 import React from "react"
 import s from "../css/products.module.css"
 import arrowDx from "../../../../../images/arrow_dx.png"
 import imgInfoPrimary from "../../../../../images/info_primary.png"
 
 
 const PriceItem = ({ price, isTinaba = false, soldout = false, onClick = null }) => {
   return <div className={`flex flex-1 flex-row items-center cursor-pointer ${s.priceContainer}`} onClick={onClick}>
     <div className={`flex-grow ${isTinaba && !soldout ? 'text-primary' : 'text-black'} `}>
       <div className={`flex flex-row font-rg text-7 leading-6_1 desktop:text-6 desktop:leading-6_1 items-center ${s.priceItemTitle}`}>
         { isTinaba ? 'Con Tinaba Hit' : 'Prezzo' } 
         { isTinaba && <a href="#come_funziona_container" onClick={(e) => { e.stopPropagation() }}><img src={imgInfoPrimary} className={`${s.imgInfoPrimary}`} /></a>}
       </div>
       <div className="font-bd text-5 leading-8 desktop:text-2" style={{ lineHeight: '24px', marginTop: '3px' }}>{price} €</div>
     </div>
     <div><img src={arrowDx} style={{ width: '10px' }} alt="vedi dettaglio prezzo" /></div>
   </div>
 }

 export default PriceItem
 